import React from 'react';

import s from '../MediaAndNews.module.css';
import {infoType} from '../../../types/TypesNews';
import {useClickOutside} from '../../../hooks/useClickOutside';
import CommonSvgSelector from '../../../assets/common/SVG/CommonSvgSelector';
import BrownButton from '../../../Components/Buttons/BrownButton';
type Props = {
	open: boolean;
	setOpen: (open: boolean) => void;
	buttonText: string;
	categoriesList: infoType[] | null;
	handleChangeCategory: any;
	setCurrentCategoryName: (value: string) => void;
	currentCategoryName: string;
};
const NewsCategorySelector: React.FC<Props> = ({
	currentCategoryName,
	open,
	setOpen,
	buttonText,
	categoriesList,
	handleChangeCategory,
	setCurrentCategoryName,
}) => {
	const handleCloseCategoryList = () => {
		setOpen(false);
	};
	const containerRef = useClickOutside<HTMLDivElement>(handleCloseCategoryList);
	const handleClickClearButton = () => {
		setCurrentCategoryName(buttonText);
		handleChangeCategory(null);
	};
	return (
		<div className={s.buttonContainer} ref={containerRef}>
			<BrownButton
				text={currentCategoryName}
				onClick={() => {
					setOpen(!open);
				}}
				type="button"
				className="media-header__btn"
			/>
			{currentCategoryName !== buttonText && (
				<button onClick={handleClickClearButton} className={s.clearButton}>
					<CommonSvgSelector id={'deleteCross'} />
				</button>
			)}
			{open && categoriesList && (
				<ul className={`${s.categoryOptionsContainer}`}>
					{categoriesList?.map((category: infoType) => (
						<li
							role="button"
							tabIndex={0}
							key={`categoryList${category.id}`}
							onClick={() => {
								handleChangeCategory(category.id);
								setCurrentCategoryName(category.name);
							}}
							className={s.categoryOptionsItem}
						>
							{category.name}
						</li>
					))}
				</ul>
			)}
		</div>
	);
};

export default NewsCategorySelector;
